
import taxInfo from '@/store/constants/tax.constants';

export default {
  namespaced: true,
  state: {
    taxInfo,
    salaryEstimator: {
      cardTitle: 'Increment Card',
      formDefaults: {
        salary: 100000,
        minIncrement: 35,
        salaryIncRate: 5,
      },
      taxValues: [5, 10, 15, 20, 25, 30],
      resultAttributes: {
        salary: 'Current Salary (per month)',
        nextSalaryPerMonth: 'Next Salary (per month)',
        minIncrement: 'Min. Increment',
        totalSalary: 'Total Salary',
        totalSalaryExclTax: 'Total Salary (excl. tax)',
      },
      currencyAttributes: ['salary', 'totalSalary', 'totalSalaryExclTax', 'nextSalaryPerMonth'],
    },
    taxCalculator: {
      cardTitle: 'Tax Break-up',
      resultAttributes: {
        totalIncome: 'Total Income',
        standardDeduction: 'Standard Deduction',
        totalDeduction: 'Total Deductions',
        taxPercent: 'Tax Percent (%)',
        cessPercent: 'Cess (%)',
        taxableAmount: 'Taxable Amount',
        taxExclCess: 'Taxable Amount (excl. cess)',
        tax: 'Tax',
        salaryPerMonth: 'Salary (per month)',
      },
      formDefaults: {
        totalIncome: 300000,
        totalDeduction: 0,
        employmentType: 'Employee',
        budgetYear: {
          value: 'budget_20192020',
          text: '2019-20',
        },
        ageGroup: {
          value: 'groupRegular',
          text: '0 - 60 Yrs',
        },
      },
      budgetYearValues: [{
        value: 'budget_20192020',
        text: '2019-20',
      }, {
        value: 'budget_20202021',
        text: '2020-21',
      }],
      ageGroupValues: [{
        value: 'groupRegular',
        text: 'Upto 60 Yrs',
      }, {
        value: 'groupSenior',
        text: '60 - 80 Yrs',
      }, {
        value: 'groupSuperSenior',
        text: '80 & above',
      }],
      employmentTypesList: [
        {
          label: 'Consultant',
        }, {
          label: 'Employee',
        },
      ],
    },
  },
  getters: {
    matchingSlab: () => (slabs, totalIncome) => {
      let slab = {};
      Object.keys(slabs).forEach((item) => {
        const currentGroup = slabs[item];
        if (totalIncome > currentGroup.minAmount
              && totalIncome <= currentGroup.maxAmount) {
          slab = {
            ...currentGroup,
          };
        }
      });
      return slab;
    },
    taxBreakup: (state, getters) => (config) => {
      const {
        budgetYear, ageGroup, totalIncome, isEmployee,
      } = config;
      let { totalDeduction } = config;
      const BYConfig = state.taxInfo[budgetYear];
      const { standardDeduction, maxDeduction } = BYConfig;
      const { slabs } = BYConfig[isEmployee ? ageGroup : 'groupConsultant'];
      if (totalDeduction > maxDeduction) {
        totalDeduction = maxDeduction;
      }
      const slab = getters.matchingSlab(slabs, totalIncome);
      const taxableAmount = totalIncome - standardDeduction - totalDeduction;
      const taxExclCess = slab.minTaxAmount + (slab.taxPercent * (taxableAmount - slab.minAmount));
      const tax = taxExclCess * (1 + slab.cessPercent);
      const salaryPerMonth = (taxableAmount - tax) / 12;
      return {
        ...slab,
        totalDeduction,
        maxDeduction,
        standardDeduction,
        taxableAmount,
        tax,
        taxExclCess,
        salaryPerMonth,
      };
    }
    ,
  },
  mutations: {},
  actions: {},
};
